"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SharedErrorCodes;
(function (SharedErrorCodes) {
    /**
     * A CSV or Excel file failed to be created in Viz.exportCrosstabAsync().
     */
    SharedErrorCodes["CrosstabCreationError"] = "crosstab-creation-error";
    /**
     * A CSV file failed to be created in Viz.exportDataAsync().
     */
    SharedErrorCodes["DataCreationError"] = "data-creation-error";
    /**
     * An invalid aggregation was specified for the filter, such as setting a range filter to "SUM(Sales)" instead of
     * "Sales".
     */
    SharedErrorCodes["InvalidAggregationFieldName"] = "invalid-aggregation-field-name";
    /**
     * A filter operation was attempted on a field that does not exist in the data source.
     */
    SharedErrorCodes["InvalidFilterFieldName"] = "invalid-filter-name";
    /**
     * A filter operation was attempted using a value that is the wrong data type or format.
     */
    SharedErrorCodes["InvalidFilterFieldValue"] = "invalid-filter-fieldValue";
    /**
     * An invalid date value was specified in a Sheet.selectMarksAsync() call for a date field.
     */
    SharedErrorCodes["InvalidSelectionDate"] = "invalid-selection-date";
    /**
     * A field was specified in a Sheet.selectMarksAsync() call that does not exist in the data source.
     */
    SharedErrorCodes["InvalidSelectionFieldName"] = "invalid-selection-fieldName";
    /**
     * An invalid value was specified in a Sheet.selectMarksAsync() call.
     */
    SharedErrorCodes["InvalidSelectionValue"] = "invalid-selection-value";
    /**
     * A parameter did not include a valid sheet selection for exporting.
     */
    SharedErrorCodes["InvalidSelectionSheet"] = "invalid-selection-sheet";
    /**
     * An error occurred within the Tableau API. Contact Tableau Support.
     */
    SharedErrorCodes["InternalError"] = "internal-error";
    /**
     * A parameter is not the correct data type or format. The name of the parameter is specified in the Error.message field.
     */
    SharedErrorCodes["InvalidParameter"] = "invalid-parameter";
    /**
     * A PDF file failed to be created in Viz.exportPDFAsync().
     */
    SharedErrorCodes["PDFCreationError"] = "pdf-creation-error";
    /**
     * A PowerPoint file failed to be created in Viz.exportPowerPointAsync().
     */
    SharedErrorCodes["PowerPointCreationError"] = "powerpoint-creation-error";
    /**
     * An operation was attempted on a sheet that is not active or embedded within the active dashboard.
     */
    SharedErrorCodes["NotActiveSheet"] = "not-active-sheet";
    /**
     * Property or Function is not supported within the Tableau API.
     */
    SharedErrorCodes["ImplementationError"] = "wrong-implementation";
    /**
     * Can occur when two incompatible calls are triggered together.
     */
    SharedErrorCodes["ApiExecutionError"] = "api-execution-error";
    /**
     * A general-purpose server error occurred. Details are contained in the Error object.
     */
    SharedErrorCodes["ServerError"] = "server-error";
    /**
     * Can occur when an api call times out.
     */
    SharedErrorCodes["Timeout"] = "timeout";
})(SharedErrorCodes = exports.SharedErrorCodes || (exports.SharedErrorCodes = {}));
//# sourceMappingURL=Enums.js.map